import moment from "moment";
import { t } from "../i18n";

export const ENVIRONMENT = process.env.REACT_APP_ENV;
export const isLocal = ENVIRONMENT === "local";
export const isProduction =
  ENVIRONMENT === "production" || ENVIRONMENT === "staging";
export const isOnPremise = process.env.REACT_APP_ON_PREMISE;

export const LIVE_SITE_URL = "connect.alem.health";
export const DEV_SITE_URLS = [
  "devahconnect.z23.web.core.windows.net",
  "connect-dev.cloud.alem.health",
];
export const LOCAL_VIEWER_URL_SEGMENT = ":8088/viewer-link/study/"; // {study_guid}/
export const LOCAL_STATUS_URL_SEGMENT = ":8088/api/box/hardware-status/all/"; // {study_guid}/


export const BURN_CD_URL = '/api/box/studies/' 
export const LOCAL_STORAGE_PREFIX = 'front-desk-'
export const LOCAL_STORAGE_POST_LOGIN_REDIRECT_SEARCH = LOCAL_STORAGE_PREFIX + ENVIRONMENT + '-post-login-redirect-search'
export const LOCAL_STORAGE_JWT_KEY = LOCAL_STORAGE_PREFIX + 'jwt-id-token'
export const LOCAL_STORAGE_PERSISTENT_STATE_KEY = LOCAL_STORAGE_PREFIX + ENVIRONMENT + '-state'
export const LOCAL_STORAGE_POST_LOGIN_REDIRECT_URL = LOCAL_STORAGE_PREFIX + ENVIRONMENT + '-post-login-redirect'

export const LOCAL_STORAGE_AUTH_KEY = {
  USER_PROFILE: LOCAL_STORAGE_PREFIX + ENVIRONMENT + "-auth-user-profile",
  SELECTED_FACILITY_ID: LOCAL_STORAGE_PREFIX + ENVIRONMENT + "-auth-selected-facility-id",
  ACCESS_TOKEN: LOCAL_STORAGE_PREFIX + ENVIRONMENT + "-auth-access-token",
  ID_TOKEN: LOCAL_STORAGE_PREFIX + ENVIRONMENT + "-auth-id-token",
  EXPIRES_AT: LOCAL_STORAGE_PREFIX + ENVIRONMENT + "-auth-expires-at",
};
export const LOCAL_STORAGE_PROVIDERS_LIST_KEY =
  LOCAL_STORAGE_PREFIX + ENVIRONMENT + "-providers-list";
export const LOCAL_STORAGE_REPORT_TEMPLATES_KEY =
  LOCAL_STORAGE_PREFIX + ENVIRONMENT + "-report-template";
export const LOCAL_STORAGE_FREE_TEXT_REPORT_TEMPLATES_KEY =
  LOCAL_STORAGE_PREFIX + ENVIRONMENT + "-free-text-report-template";
export const LOCAL_STORAGE_HUB_DEVICES_LIST_KEY =
  LOCAL_STORAGE_PREFIX + ENVIRONMENT + "-hub-devices-list";

export const LOCAL_STORAGE_COUNTRIES_LIST_KEY =
  LOCAL_STORAGE_PREFIX + ENVIRONMENT + "-countries_list_key";

export const DB_NAME = "alemhealth-connect-" + ENVIRONMENT;
export const REPORT_STORE = "report-draft-store";
export const STORE_MODE = "readwrite";
export const AUTO_SAVE_DELAY_IN_MILLISECONDS = 3000;

export const INVITE_FACILITY_FORM_NAME = "inviteFacilityForm";
export const STUDY_CREATE_FORM_NAME = "studyCreateForm";
export const STUDY_SHARE_FORM_NAME = "studyShareFormName";
export const AZURE_STORAGE_DOCUMENT_FORM_NAME = "azureStorageDocumentForm";
export const AZURE_STORAGE_DOCUMENT_MANUAL_REPORT_FORM_NAME =
  "azureStorageDocumentManualReportForm";
export const AZURE_STORAGE_DOCUMENT_RENAME_FORM_NAME =
  "azureStorageDocumentRenameForm";
export const AZURE_STORAGE_DOCUMENT_CHANGE_TYPE_FORM_NAME =
  "azureStorageDocumentChangeTypeForm";
export const STUDY_EDIT_FORM_NAME = "studyEditForm";
export const REPORT_EDIT_FORM_NAME = "reportEditForm";
export const SETTINGS_USER_EDIT_FORM_NAME = "userEditForm";
export const SETTINGS_USER_SIGNATURE_FORM_NAME = "userSignatureForm";
export const SETTINGS_GENERAL_FORM_NAME = "settingsGeneralForm";
export const REJECT_ASSIGNMENT_FORM_NAME = "rejectAssignmentForm";
export const PRELIMINARY_REPORT_NOTIFICATION_FORM =
  "preliminaryReportNotificationForm";
export const QUESTIONNAIRE_FORM_NAME = "questionnaireForm";
export const QUESTIONNAIRE_SELECTION_FORM_NAME = "questionnaireSelectionForm";

export const PRIMARY_INFO_FORM_NAME = "primaryInfoForm";
export const REPORTING_PREFERENCES_FORM_NAME = "reportingPreferencesForm";
export const RECEIVING_PREFERENCES_FORM_NAME = "receivingPreferencesForm";
export const INVITE_MY_COLLEAGUE_FORM_NAME = "inviteMyColleagueForm";
export const WEB_UPLOADER_FORM_NAME = "webUploaderForm";
export const FACILITY_FORM_NAME = "facilityForm";
export const REPORTING_STUDY_FORM_NAME = "reportingStudyForm";
export const ONBOARDING_FORM_NAME = "onboardingForm";
export const UPDATE_TEMPLATE_FORM_NAME = "updateTemplateForm";
export const UPLOAD_TEMPLATE_FORM_NAME = "uploadTemplateForm";
export const RADIOLOGY_FORM_NAME = "radiologyForm";
export const STUDIES_FILTER_FORM = "studiesFilterForm";

export const LOCAL_STORAGE_FREE_TEXT_IMAGE_URL =
  LOCAL_STORAGE_PREFIX + ENVIRONMENT + "-free-text-image-url";

export const TAB_QUESTIONNAIRE = "questionnaire";
export const TAB_QUESTIONNAIRE_TITLE = "Questionnaire";
export const TAB_RELATED_DOCUMENTS = "related-documents";
export const TAB_RELATED_DOCUMENTS_TITLE = "Related Documents";
export const TAB_REPORT = "report";
export const TAB_REPORT_TITLE = "Report";
export const TAB_STUDY = "study";
export const TAB_STUDY_TITLE = "Study";
export const TAB_PRIORS = "priors";
export const TAB_PRIORS_TITLE = "Priors";
export const TAB_TIMELINE = "timeline";
export const TAB_TIMELINE_TITLE = "Timeline";
export const TAB_KNOWLEDGE_BASE = "knowledgebase";
export const TAB_KNOWLEDGE_BASE_TITLE = "Knowledge Base";

export const CHAT_INPUT_FORM_NAME = "chatInputForm";

export const ROLES = {
  COORDINATOR: "coordinator",
  INDEPENDENT_RADIOLOGIST: "independent radiologist",
  RADIOGRAPHER: "radiographer",
  RADIOLOGIST: "radiologist",
};

export const STUDY_DATE_TIME_FORMATS = {
  upload: {
    patientDob: "YYYY-MM-DD",
    studyDate: "YYYY-MM-DD",
    studyTime: "hh:mm:ss",
  },
  patient: {
    dob: "YYYY-MM-DD",
  },
  date: "DD MM YYYY",
  birthDate: "DD MMM YYYY",
  year: "YYYY",
  studyList: "DD MMM YYYY [[]HH:mm[]]",
  workList: "DD MMM YYYY, hh:mm A",
  time: "H:mm A",
  questionnaire: {
    lastMenstrualDate: "DD / MM / YYYY",
    lastMammogramDate: "DD / MM / YYYY",
  },
  createdAt: "HH[H] mm[M] s[S]",
  report: {
    signedToday: "H:mm A",
    signedBefore: "DD MMM YYYY H:mm A",
  },
  print: {
    requestedAt: "YYYY-MM-DD",
    reportedAt: "YYYY-MM-DD",
    patientDob: "YYYY-MM-DD",
  },
};

export const parameterKeyMapper = {
  accessionNumber: "accession_number",
  assignTo: "radiologist",
  bodyPart: "body_part",
  createdAt: "ordering",
  modality: "modality",
  offset: "offset",
  limit: "limit",
  patientId: "patient_id",
  patientName: "patient_name",
  priority: "priority",
  radiologist: "radiologist",
  searchText: "patient_search",
  facilityName: "facility_name",
  status: "status",
  fromDate: "from_date",
  toDate: "to_date",
  assignments: "assignments",
  sorting: "sorting",
};

// export const parameterSortMapper = {
//   createdAt: {
//     ascend: 'created_at',
//     descend: '-created_at'
//   }
// }

export const defaultStudiesDateSelect = "created_at";
export const defaultStudiesDateOrder = "descend";

export const parameterSortMapper = [
  { id: "study_datetime", name: "study_table.study_date" },
  { id: "created_at", name: "study_table.study_uploaded" },
  { id: "updated_at", name: "study_table.last_uploaded" },
];

export const configurationKeyMapper = {
  modality: "modality",
  body_part: "body_part",
  radiologist: "radiologist",
  facility_name: "facility_name",
  assignments: "assignments",
  status: "status",
};

export const eligibleRolesForStudyActions = [
  ROLES.RADIOLOGIST,
  ROLES.INDEPENDENT_RADIOLOGIST,
];

export const NOTIFICATION_MESSAGE_DURATION = 5;

export const AVATAR_SHORT_NAME_LENGTH = 9;
export const ASSIGNEE_SHORT_NAME_LENGTH = 10;
export const PATIENT_SHORT_NAME_LENGTH = 20;

export const DEBOUNCE_DELAY_IN_MILLISECONDS = 1000;

export const StatusLabels = {
  CREATED: { key: "CREATED", color: "#15A9E1", label: "Created" },
  STORED: { key: "STORED", color: "#15A9E1", label: "Stored" },
  ASSIGNED: { key: "ASSIGNED", color: "#15A9E1", label: "Assigned" },
  ARCHIVED: { key: "ARCHIVED", color: "#15A9E1", label: "Archived" },
  NEW: { key: "NEW", color: "#15A9E1", label: "Ready for Reporting" },
  DRAFT: { key: "DRAFT", color: "#FAAD14", label: "Draft Report" },
  FINALISED: { key: "FINALISED", color: "#52C41A", label: "Final Report" },
  REVISED: { key: "REVISED", color: "#F5222D", label: "Revised Report" },
  WAITING_FOR_TRANSCRIBE: {
    key: "WAITING_FOR_TRANSCRIBE",
    color: "#000000",
    label: "Waiting for Transcribe",
  },
  TRANSCRIBING: {
    key: "TRANSCRIBING",
    color: "#000000",
    label: "Transcribing Report",
  },
  PROVISIONAL: {
    key: "PROVISIONAL",
    color: "#000000",
    label: "Provisional Report",
  },
};

export const ReferringPhysicianConfig = {
  REFERRING_PHYSICIAN_NAME: "referring_physician_name",
  REFERRING_PHYSICIAN_GUID: "referring_physician_guid",
  REFERRING_PHYSICIAN: "referring_physician",
};

export const CustomSelectFieldConfig = {
  TYPE_SELECT: "fixed",
  TYPE_TEXT: "custom",
};

export const segmentIOWriteKey = process.env.REACT_APP_SEGMENT_IO_WRITE_KEY;

export const ALEMHEALTH_UPLOADER_DOWNLOAD_LINK =
  "https://download.alem.health/AlemHealthConnect.exe";

export const ALEMHEALTH_EMAIL_SUPPORT =
  "mailto:support@alemhealth.com?Subject=Support%20Request:%20";

export const ALEMHEALTH_SUPPORT_LINK =
  "https://alemhealth.zendesk.com/hc/en-us/categories/360000324791-AlemHealth-for-Healthcare-Providers";

export const ALEMHEALTH_UPLOADER_GETTING_STARTED =
  "https://alemhealth.zendesk.com/hc/en-us/articles/360007071191-Getting-Started-with-AlemHealth-Connect-Uploader-for-Windows";

export const TICK_AMOOUNT_IN_MILLISECONDS = 1000;
export const SECONDS_IN_A_MINUTE = 60;
export const SECONDS_IN_AN_HOUR = 3600;
export const SECONDS_IN_A_DAY = 86400;
export const MILLISECONDS_IN_A_DAY = 86400000;

export const actionableFindings = {
  none: { label: "None", value: "" },
  critical_findings: { label: "Critical Findings", value: "Critical Findings" },
  urgent_findings: { label: "Urgent Findings", value: "Urgent Findings" },
  significant_unexpected_findings: {
    label: "Significant Unexpected Findings",
    value: "Significant Unexpected Findings",
  },
};

export const gender = {
  M: { label: t("common.male"), value: "M" },
  F: { label: t("common.female"), value: "F" },
  O: { label: t("common.other"), value: "O" },
};

export const PRIORITY_ROUTINE = "routine";
export const PRIORITY_URGENT = "urgent";

export const priority = {
  routine: { label: "Routine", value: "routine", sla_countdown: 24 },
  expedite: { label: "Expedite", value: "expedite", sla_countdown: 24 },
  priority: { label: "Priority", value: "priority", sla_countdown: 24 },
  urgent: { label: "Urgent", value: "urgent", sla_countdown: 3 },
  emergent: { label: "Emergent", value: "emergent", sla_countdown: 1 },
};

export const physicians = [];

export const REPORT_PDF_PRINT_LAYOUT = {
  DATA: "data_only",
  FOOTER_ONLY: "footer_only",
  HEADER_ONLY: "header_only",
  NORMAL: "normal",
};

export const REPORT_PDF_PRINT_OPTIONS = {
  PRINT_PDF_WITH_DATA_ONLY: {
    type: REPORT_PDF_PRINT_LAYOUT.DATA,
    label: "print_the_content_only",
  },
  PRINT_PDF_WITH_FOOTER_ONLY: {
    type: REPORT_PDF_PRINT_LAYOUT.FOOTER_ONLY,
    label: "print_content_with_footer",
  },
  PRINT_PDF_WITH_HEADER_ONLY: {
    type: REPORT_PDF_PRINT_LAYOUT.HEADER_ONLY,
    label: "print_content_with_header",
  },
  PRINT_PDF_NORMAL: {
    type: REPORT_PDF_PRINT_LAYOUT.NORMAL,
    label: "print_full_report",
  },
  PRINT_PREVIEW: {
    type: REPORT_PDF_PRINT_LAYOUT.NORMAL,
    label: "print_preview",
  },
};

export const dateFilters = {
  TODAY: moment().format('l'),
  THIS_WEEK: moment()
    .subtract(7, 'days')
    .format('l'),
  THIS_MONTH: moment()
    .subtract(30, 'days')
    .format('l'),
  LAST_MONTH: moment()
    .subtract(60, 'days')
    .format('l')
};

export const studyPriorities = [
  'routine',
  'expedite',
  'priority',
  'urgent',
  'emergent'
];
export const labeledStudyPriorities = [
  'expedite',
  'priority',
  'urgent',
  'emergent'
];

const { TODAY, THIS_WEEK, THIS_MONTH, LAST_MONTH } = dateFilters;

export const dateFilterStrings = {
  TODAY: 'today',
  THIS_WEEK: 'week',
  CUSTOM: 'custom'
};

export const dateOptions = [
  { value: TODAY, label: 'Today' },
  {
    value: THIS_WEEK,
    label: 'This Week'
  },
  {
    value: THIS_MONTH,
    label: 'This Month'
  },
  {
    value: LAST_MONTH,
    label: 'Last Month'
  }
];

export const REMOVE_STUDY_OPTIONS = {
  REPORTED_MANUALLY: { type: "REPORTED_MANUALLY", label: "Reported Manually" },
  REJECT_STUDY: { type: "REJECT_STUDY", label: "Reject Study" },
  NO_REPORT: { type: "NO_REPORT", label: "No Report Required" },
};

export const MIN_HEIGHT_FOR_FULL_SIDEBAR = 575;

export const NAV_STATES = {
  WEB: "web-uploader",
  WINDOWS: "windows-uploader",
  INVITE: "image-from-facility",
};

export const facilityTypeOptions = [
   { label: 'Diagnostic Imaging Centre', value: 'diagnostic-imaging-center' },
   { label: 'Hospital', value: 'hospital' },
   { label: 'Health Clinic', value: 'health-clinic' },
   { label: 'Assisted/Senior Living Facility', value: 'senior-living-facility' },
   { label: 'Speciality Clinic', value: 'speciality-clinic' },
   { label: 'Teleradiology Provider', value: 'teleradiology-provider' },
   { label: 'Other', value: 'other' },

]
export const remportTemplateSharingStatusType = {
  private: { label: "Private", value: "Private" },
  facility: { label: "Facility", value: "Facility" },
  public: { label: "Public", value: "Public" },
};

export const specialtyTypeOptions = {
  "abdominal-imaging": {
    label: "Abdominal Imaging",
    value: "Abdominal Imaging",
  },
  "breast-imaging": { label: "Breast Imaging", value: "Breast Imaging" },
  "cardiac-imaging": { label: "Cardiac Imaging", value: "Cardiac Imaging" },
  "emergency radiology": {
    label: "Emergency Radiology",
    value: "Emergency Radiology",
  },
  "general-radiology": {
    label: "General Radiology",
    value: "General Radiology",
  },
  "musculoskeletal-imaging": {
    label: "Musculoskeletal Imaging",
    value: "Musculoskeletal Imaging",
  },
  neuroradiology: { label: "Neuroradiology", value: "Neuroradiology" },
  "neuro-interventional": {
    label: "Neuro-interventional Radiology",
    value: "Neuro-interventional Radiology",
  },
  "nuclear-medicine": { label: "Nuclear Medicine", value: "Nuclear Medicine" },
  "pediatric-radiology": {
    label: "Pediatric Radiology",
    value: "Pediatric Radiology",
  },
  "prostate-radiology": {
    label: "Prostate Radiology",
    value: "Prostate Radiology",
  },
  "thoraric-imaging": { label: "Thoracic Imaging", value: "Thoracic Imaging" },
  "vascular-and-interventional-radiology": {
    label: "Vascular and Interventional Radiology",
    value: "Vascular and Interventional Radiology",
  },
};

export const userType = {
  Management: { label: "Management", value: "Management" },
  Radiographer: { label: "Radiographer", value: "Radiographer" },
  Radiologist: { label: "Radiologist", value: "Radiologist" },
  Clinician: { label: "Clinician", value: "Clinician" },
  "Radiologist Assistant": {
    label: "Radiologist Assistant",
    value: "Radiologist Assistant",
  },
  Coordinator: { label: "Coordinator", value: "Coordinator" },
  Administrator: { label: "Administrator", value: "Administrator" },
  "Independent Radiologist": {
    label: "Independent Radiologist",
    value: "Independent Radiologist",
  },
};

export const dicomZipDownloadStatus = {
  SUBMITTED: { label: "Request submitted", value: "SUBMITTED" },
  DOWNLOADED: { label: "Download finished", value: "DOWNLOADED" },
};

export const SLACK_APP_TYPE = process.env.REACT_APP_SLACK_MODE;
export const SLACK_WEB_HOOK =
  // "https://alemhealthtech.slack.com/archives/C05H943V9Q9";

"https://hooks.slack.com/services/T0EM5SUKY/B015WGY1R6X/C05H943V9Q9";
// https://alemhealthtech.slack.com/archives/C05H943V9Q9



export const PUBNUB_STUDY_SYNC = {
  PUBLISH_KEY: process.env.REACT_APP_PUBLISH_KEY_STUDY_SYNC,
  SUBSCRIBE_KEY: process.env.REACT_APP_SUBSCRIBE_KEY_STUDY_SYNC,
  CHANNEL: process.env.REACT_APP_STUDY_SYNC_CHANNEL,
};

export const PUBNUB_FACILITY_STATUS_SYNC = {
  SUBSCRIBE_KEY: process.env.REACT_APP_SUBSCRIBE_KEY_FACILITY_STATUS_SYNC,
};

export const USER_NOTIFICATION = {
  SUBSCRIBE_KEY: process.env.REACT_APP_SUBSCRIBE_KEY_USER_NOTIFICATION,
  PUBLISH_KEY: process.env.REACT_APP_PUBLISH_KEY_USER_NOTIFICATION,
  CHANNEL_PREFIX: "user.notification.",
};

export const KLOUDLESS_APP_ID = process.env.REACT_APP_KLOUDLESS_APP_ID;


export const validUuidRegularExpression =
  /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i;
export const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

export const REDIRECT_QR = "https://signup.alem.health/qr-scanned?id="
